function a(n, r) {
  return function(t) {
    return t == null ? !1 : t[n] === r && (r !== void 0 || n in Object(t));
  };
}
var e = a;
export {
  e as default
};
//# sourceMappingURL=_matchesStrictComparable.js.map
